<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .paragraph-links

        +container-grey

        &__container
            +container2
            margin: 0 auto
            padding: 0
            +media("<=1100px")
                padding: 0
                margin-top: 1rem

        .title--2
            margin-bottom: 2rem

        &__links
            position: relative
            width: 100%
            padding: 0
            box-sizing: border-box
            display: flex
            flex-direction: row
            flex-wrap: wrap

            +media("<=desktop")
                padding: 0
            +media("<=768px")
                flex-direction: column

            &__link
                background-color: white
                border-radius: 0.2rem
                box-shadow: 0 0 1.5rem 0.2rem rgba(0, 0, 0, 0.2)
                flex-basis: calc(33% - 1.5rem)
                margin-right: 1.5rem
                flex-shrink: 0
                height: 5rem
                padding: 0 2rem
                box-sizing: border-box
                position: relative
                margin-bottom: 1.5rem
                transition: transform .15s ease
                font-weight: 600
                display: flex
                align-items: center

                &:hover
                    transform: scale(1.03)

                &:before
                    position: absolute
                    content: ''
                    top: 0
                    left: 0
                    background-color: $color-base
                    width: 0.5rem
                    height: 100%
                    border-radius: 0.2rem 0 0 0.2rem

                +media("<=768px")
                    flex-basis: 100%
                    padding-right: 2.5rem
                    line-height: 1.4
                    margin-right: 0
                    min-height: 4rem

                &:after
                    font-family: element-icons!important
                    content: "\E604"
                    display: block
                    position: absolute
                    right: 1rem
                    color: $color-gray-medium
                    top: calc(50% - 0.5rem)
                    transition: transform $speed-fast $authentic-motion

                a:hover
                    color: $color-base
                    text-decoration: underline
        .button
            display: none
            width: 100%
            +media("<=768px")
                display: block

</style>



<script>
    import $ from 'jquery'

    export default {

        data() {
            return {
                buttonLegend: "",
                mode: "close"
            }
        },

        mounted() {
            if ( $(this.$el).find('.button').length )
                this.toggle();
        },

        methods: {

            toggle: function() {
                let $items = $(this.$el).find('.paragraph-links__links__link');
                let $button = $(this.$el).find('.button');
                let isMobile = ( $(window).width() <= 768 ); // TODO Handle on resize
                if (isMobile) {
                    if ( this.mode === "open" ) {
                        $items.show();
                        this.mode = "close";
                        this.buttonLegend = $button.attr('minus');
                    }
                    else {
                        $items.hide();
                        $items.eq(0).show();
                        $items.eq(1).show();
                        $items.eq(2).show();
                        $items.eq(3).show();

                        this.mode = "open";
                        this.buttonLegend = $button.attr('plus');
                    }
                }

            },

            scrollToLinks() {
                $('html, body').animate({
                    scrollTop: $(".paragraph-links").offset().top - 50
                });
            }

        }

    }


</script>
